import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { SplitRoutes } from 'react-router-split-routes';

import Nav from '../components/nav/Nav';
import ErrorPanel from '../components/error/ErrorPanel';
import { DelayedSpinner } from '../components/loading/Loading';

import App from '../containers/App';
import Login from '../containers/auth/Login';
import Logout from '../containers/auth/Logout';
import Auth from '../containers/auth/Auth';


const SplitLoading = () => (
  <DelayedSpinner />
);

const SplitError = ({ route, className }) => (
  <ErrorPanel className={className ? className : "split-error"} message={'Error loading route' + (route ? ': ' + route.path : '')} />
);

const SplitNavLoading = props => (
  <Nav {...props} content={<SplitLoading {...props} />} />
);

const SplitNavError= props => (
  <Nav {...props} content={<SplitError {...props} />} />
)

const RouteError = ({ location, className }) => (
  <ErrorPanel className={className} message={(location && location.pathname) ? 'The page ' + location.pathname + ' could not be found' : 'The page you requested could not be found'} />
);

const NavRouteError = props => (
  <Nav {...props} content={<RouteError {...props} />} />
);

const routeOptions = {
  addParamProps: true,
  routeProp: false,
  matchProp: false
};

const routes = [
  {
    path: '/',
    exact: true,
    redirect: '/dashboards'
  },
  {
    path: '/widgets',
    exact: true,
    redirect: '/widgets/creator'
  },
  {
    props: {
      SplitLoadingComponent: SplitNavLoading,
      SplitErrorComponent: SplitNavError
    },
    component: App,
    routes: [
      {
        path: '/login',
        exact: true,
        component: Login
      },
      {
        path: '/logout',
        exact: true,
        component: Logout
      },
      {
        component: Auth,
        routes: [
          {
            path: '/dashboards',
            props: {
              className: 'reveal-background-styled'
            },
            componentPath: 'DashboardRoot',
            routes: [
              {
                path: '/dashboards',
                exact: true,
                componentPath: 'DashboardLanding'
              },
              {
                path: '/dashboards/new',
                exact: true,
                componentPath: 'DashboardCreate'
              },
              {
                path: '/dashboards/:dashboardId',
                componentPath: 'DashboardDetailRoot',
                routes: [
                  {
                    path: '/dashboards/:dashboardId',
                    exact: true,
                    componentPath: 'DashboardDetail'
                  },
                  {
                    path: '/dashboards/:dashboardId/widget_links/:widgetLinkId',
                    exact: true,
                    componentPath: 'DashboardWidgetLinkDetail'
                  },
                  {
                    component: RouteError
                  }
                ]
              },
              {
                component: RouteError
              }
            ]
          },
          {
            path: '/widgets/creator',
            props: {
              className: 'reveal-background-styled'
            },
            exact: true,
            componentPath: 'WidgetCreator'
          },
          {
            path: '/widgets',
            props: {
              className: 'reveal-background-styled'
            },
            componentPath: 'WidgetRoot',
            routes: [
              {
                path: '/widgets/:widgetId',
                exact: true,
                componentPath: 'WidgetDetail'
              },
              {
                component: RouteError
              }
            ]
          },
          {
            path: '/widget_links',
            props: {
              className: 'reveal-background-styled'
            },
            componentPath: 'WidgetLinkRoot',
            routes: [
              {
                path: '/widget_links/:widgetLinkId',
                exact: true,
                componentPath: 'WidgetLinkDetail'
              },
              {
                component: RouteError
              }
            ]
          },
          {
            path: '/test',
            componentPath: 'test/TestRoot',
            routes: [
              {
                path: '/test',
                exact: true,
                componentPath: 'test/TestIndex',
              },
              {
                path: '/test/connect',
                exact: true,
                componentPath: 'test/TestConnect'
              },
              {
                path: '/test/connect_dynamic',
                exact: true,
                componentPath: 'test/TestConnectDynamic'
              },
              {
                path: '/test/nested',
                exact: true,
                componentPath: 'test/TestNested'
              },
              {
                component: RouteError
              }
            ]
          },
          {
            path: '/params',
            componentPath: 'params/ParamsRoot',
            routes: [
              {
                path: '/params',
                exact: true,
                componentPath: 'params/ParamsIndex'
              },
              {
                path: '/params/endpoints',
                exact: true,
                componentPath: 'params/ParamsEndpoints'
              },
              {
                path: '/params/connected',
                exact: true,
                componentPath: 'params/ParamsConnected'
              },
              {
                component: RouteError
              }
            ]
          },
          {
            component: RouteError
          }
        ]
      }
    ]
  }
];

let loadSplitComponentForPath = () => { };
if (process.env.NODE_ENV === 'production') {
  loadSplitComponentForPath = (containerPath, success, error) => {
    try {
      require('split-chunk-loader?name=route-[name]!./split/' + containerPath)(success, error);
    }
    catch (e) {
      error(e);
    }
  }
}
else {
  loadSplitComponentForPath = (containerPath, success, error) => {
    try {
      success(require('./split/' + containerPath));
    }
    catch (e) {
      error(e);
    }
  }
}

export default class Routes extends Component {

  static propTypes = {
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  render() {
    const { store, history } = this.props;

    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <SplitRoutes
            routes={routes}
            routeOptions={routeOptions}
            loadSplitComponentForPath={loadSplitComponentForPath}
          />
        </ConnectedRouter>
      </Provider>
    );
  }
}
